import css from "./NotFound.module.css";
import buttonCss from "../../common-styling/Button.module.css";
import { useNavigate } from "react-router-dom";

const NotFound: React.FC<object> = () => {
  const navigate = useNavigate();
  return (
    <div className={css.notFound}>
      <h1>Page Not Found</h1>
      <p>
        The page you requested could not be found. If you think this is an error
        on our end, please contact{" "}
        <a href="mailto:accounts@unrulycorp.com">Unruly support</a>.
      </p>
      <button
        onClick={() => {
          navigate("/");
        }}
        className={[buttonCss["action-button"], css.homeButton].join(" ")}
      >
        Unruly Home
      </button>
    </div>
  );
};

export default NotFound;
